import { render, staticRenderFns } from "./modalDetail.vue?vue&type=template&id=2abcc4d0&"
import script from "./modalDetail.vue?vue&type=script&lang=js&"
export * from "./modalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports